export default __webpack_public_path__ + "static/media/plant.87c38417.png";